import { ArpeggiCompositionV5 } from '../types/arpeggiComposition'

/**
 * Javascript helper functions to convert from hex string to arpeggi composition.
 *
 * Inverse of arpeggiCompositionToByteArray().
 *
 * TODO once we switch on-chain event listener to TS, move this into
 *  shared/types/arpeggiComposition.ts byteArrayToArpeggiComposition.
 */
export const hexStringToArpeggiComposition = (hexString: string) => {
  const byteArray = fromHexString(hexString)
  return {
    version: byteArray[0],
    compressedSnapshot: Array.from(byteArray.slice(1))
  }
}

export const fromHexString = (hexString: string) => {
  var substringPrefix = '0x'
  if (hexString.substring(0, 2) === substringPrefix) {
    hexString = hexString.substring(2, hexString.length)
  }

  const hexStringRegex = hexString.match(/.{1,2}/g)
  if (!hexStringRegex) throw new Error('hex regex match returned null')

  return new Uint8Array(hexStringRegex.map((byte) => parseInt(byte, 16)))
}

export const toHexString = (byteArray: Uint8Array) => {
  return Array.from(byteArray, function (byte) {
    return ('0' + (byte & 0xff).toString(16)).slice(-2)
  }).join('')
}

/**
 * Converts the ArpeggiComposition object, which contains a version integer and a byte array, into a single byte array,
 * so it can be efficiently minted to the contract.
 *
 * Inverse of byteArrayToArpeggiComposition().
 *
 * Stores the version in the first byte. Remaining bytes are the compressedSnapshot.
 */
export const arpeggiCompositionToByteArray = (
  arpeggiComposition: ArpeggiCompositionV5
): Uint8Array => {
  const arpeggiCompositionArray = new Uint8Array(arpeggiComposition.compressedSnapshot.length + 1)
  arpeggiCompositionArray.set([arpeggiComposition.version], 0)
  arpeggiCompositionArray.set(new Uint8Array(arpeggiComposition.compressedSnapshot), 1)
  return arpeggiCompositionArray
}
